export default __webpack_public_path__ + "static/media/G0800.34I-41948_-25141_0.1654019760000.40bcbe50.jpg";